import { render, staticRenderFns } from "./CasePreview.vue?vue&type=template&id=2a1e0b3f&scoped=true&"
import script from "./CasePreview.vue?vue&type=script&lang=js&"
export * from "./CasePreview.vue?vue&type=script&lang=js&"
import style0 from "./CasePreview.vue?vue&type=style&index=0&id=2a1e0b3f&scoped=true&lang=css&"
import style1 from "./CasePreview.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1e0b3f",
  null
  
)

export default component.exports